import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigate } from '@remix-run/react';

import Button from '~/components/Button';
import Modal from '~/components/Modal';
import useIsLoggedIn from '~/hooks/useIsLoggedIn';

interface Props {
  isUpgradeActive: boolean;
  onContinue?: () => void;
  onClose?: () => void;
  subscriberId?: string;
}

const PremiumMemberModal = ({ isUpgradeActive, onContinue, onClose, subscriberId }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const isLoggedIn = useIsLoggedIn();
  const [modalOpen, setModalOpen] = useState(isUpgradeActive);

  useEffect(() => {
    setModalOpen(isUpgradeActive);
  }, [isUpgradeActive]);

  const handleClose = () => {
    setModalOpen(false);
    onClose?.();
  };

  const handleContinue = () => {
    setModalOpen(false);
    onContinue?.();
  };

  const handleManageSubscriptions = () => {
    setModalOpen(false);
    navigate(`/subscribe/${subscriberId}/billing`);
  };

  return (
    <Modal
      title={t('stripe.upgrade_warning.modal.title')}
      message={t('stripe.upgrade_warning.modal.message')}
      isOpen={modalOpen}
      onClose={handleClose}
      // biome-ignore lint/correctness/noChildrenProp: Keeping for backwards compatibility
      children={
        <div className="flex w-full justify-end gap-2">
          {!isLoggedIn && <Button onClick={() => navigate('/login')}>{t('shared.cta.login')}</Button>}
          {isLoggedIn && subscriberId && (
            <Button onClick={handleManageSubscriptions} variant="secondary">
              {t('nav.links.manage')}
            </Button>
          )}
          {onContinue && (
            <Button onClick={handleContinue} variant="primary">
              {t('shared.cta.continue')}
            </Button>
          )}
        </div>
      }
    />
  );
};

export default PremiumMemberModal;
